<template>
	<div :class="classes">
		<slot />
	</div>
</template>
<script lang="ts">
export default {
	name: 'DataTableCell'
};
</script>
<script setup lang="ts">
import { computed } from 'vue';
interface Props {
	isTitle?: boolean;
	isHeader?: boolean;
	alignment?: 'left' | 'right';
}
const props = withDefaults(defineProps<Props>(), {
	isTitle: false,
	isHeader: false,
	alignment: 'right'
});

const classes = computed((): string => {
	const classes = [];

	if (props.isHeader) {
		classes.push('data-table__header');
	} else {
		classes.push('data-table__cell');
	}

	if (props.isTitle) {
		classes.push('data-table__cell--row-title');
	} else {
		classes.push(`data-table__cell--${props.alignment}-aligned`);
	}

	return classes.join(' ');
});
</script>
